
import { defineComponent, PropType } from "vue";
import Card from "@/Components/General/Card.vue";
import RfpCategory from "@/types/Rfp/RfpCategory";
import route from "ziggy-js";

export default defineComponent({
  components: {
    Card,
  },
  props: {
    category: {
      type: Object as PropType<RfpCategory>,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectedClasses() {
      if ((this as any).selected) {
        return "md-bg-gray-200";
      }

      return "";
    },
  },
  methods: {
    selectCategory() {
      if (
        route().current("rfp-categories.index") ||
        route().current("rfp-categories.show")
      ) {
        (this as any).$inertia.visit(
          route("rfp-categories.show", this.category?.id as any) +
            window.location.search,
          {
            only: ["selectedCategory"],
            preserveScroll: true,
            preserveState: true,
          }
        );
      } else {
        (this as any).$inertia.get(
          route("rfp-categories.show", this.category?.id as any) +
            window.location.search
        );
      }
    },
  },
});
